import React from 'react';
import Modal from 'react-modal';
import { useForm } from "react-hook-form";

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    borderRadius: '10px',

  },
};
Modal.setAppElement('#root');

const AppointmentForm = ({appointmentOn,modalIsOpen, closeModal, date}) => {
    
    const { register, handleSubmit, formState: { errors } } = useForm();
    const onSubmit = data => {
        data.services = appointmentOn;
        data.date = date;
        data.created = new Date();

        fetch('http://localhost:5000/addAppointment', {
            method: 'POST',
            headers: {'content-type': 'application/json'},
            body: JSON.stringify(data)
        })
        .then(res => res.json())
        .then(success => {
            if(success){
                closeModal();
                alert('Appointment Created Successfully');
            }
        })

        
    };

    return (
        <div>
            <Modal
                isOpen={modalIsOpen}
                onRequestClose={closeModal}
                style={customStyles}
                contentLabel="Example Modal"
            >
                <h2 className='text-brand text-center mb-3'>{appointmentOn}</h2>
                <p className="text-secondary text-center"><small >{date.toDateString()}</small></p>
                <form  className='p-4' onSubmit={handleSubmit(onSubmit)}>
                    <div class="mb-3">
                        <input type="text" name='name' placeholder='Your Name' class="form-control"  {...register("name", { required: true })}/>
                        {errors.name && <span class="text-danger">This field is required</span>}
                    </div>
                    <div class="mb-3">
                        <input type="text" name='phone' placeholder='Phone Number' class="form-control"  {...register("phone", { required: true })}/>
                        {errors.phone && <span class="text-danger">This field is required</span>}
                    </div>
                    <div class="mb-3">
                        <input type="email" name='email' placeholder='Email' class="form-control"  {...register("email", { required: true })}/>
                        {errors.email && <span class="text-danger">This field is required</span>}
                    </div>
                    <div className='row mb-3'>
                        <div className='col-md-4'>
                            <select class="form-select" aria-label="Default select example" {...register("gender", { required: true })}>
                                <option disabled={true} value="Not Set" selected>Select Gender</option>
                                <option value="Male">Male</option>
                                <option value="Female">Female</option>
                                <option value="Other">Other</option>
                            </select>
                            {errors.gender && <span class="text-danger">This field is required</span>}
                        </div>
                        <div className='col-md-4'>
                            <input type="text" name='Age' placeholder='Age' class="form-control"  {...register("age", { required: true })}/>
                            {errors.age && <span class="text-danger">This field is required</span>}
                        </div>
                        <div className='col-md-4'>
                            <input type="text" name='Weight' placeholder='Weight' class="form-control"  {...register("weight", { required: true })}/>
                            {errors.weight && <span class="text-danger">This field is required</span>}
                        </div>
                    </div>   
                    <div className='text-end'>
                        <button className='btn-similar px-5' type='submit'>Send</button>
                    </div>
                </form>
            </Modal>
        </div>
    );
};

export default AppointmentForm;